module.exports = __webpack_public_path__ + "img/brfore_card.6b0cd165.svg";